import {
	ContactPayload,
	ListContactsFilter,
	PaginatedResponse,
	PaginationParams,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { contactsQueryKeys } from "../query-keys/contacts.query-keys";

export const getContactsList = async (
	search: string,
	filter: ListContactsFilter,
	params: PaginationParams,
) => {
	const { data } = await privateAxios.get<PaginatedResponse<ContactPayload>>(
		"contacts",
		{
			params: {
				search,
				filter,
				page: params.page,
				limit: params.limit,
			},
		},
	);
	return data;
};

export const useGetContactsList = (
	search: string,
	filter: ListContactsFilter,
	params: PaginationParams,
) => {
	const { data, ...rest } = useQuery({
		queryKey: contactsQueryKeys.list(search, filter, params),
		queryFn: () => getContactsList(search, filter, params),
	});
	return { contacts: data, ...rest };
};

export const getContactDetails = async (contactId: number) => {
	const { data } = await privateAxios.get<ContactPayload>(
		`contacts/${contactId}`,
	);
	return data;
};

export const useGetContactDetails = (contactId: number) => {
	const { data, ...rest } = useQuery({
		queryKey: contactsQueryKeys.detail(contactId),
		queryFn: () => getContactDetails(contactId),
	});
	return { contact: data, ...rest };
};
